module.exports = __webpack_public_path__ + "img/68aa4bf.jpg";